"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
var _Icon2 = require("../../../Icon");
var _Icon3 = _interopRequireDefault(_Icon2);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
var IconSingleNeutralActionsFlag = /*#__PURE__*/
function (_Icon) {
  _inherits(IconSingleNeutralActionsFlag, _Icon);
  function IconSingleNeutralActionsFlag(props) {
    var _this;
    _classCallCheck(this, IconSingleNeutralActionsFlag);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(IconSingleNeutralActionsFlag).call(this, props));
    _this.name = 'IconSingleNeutralActionsFlag';
    _this.icon = _react2.default.createElement("svg", {
      viewBox: "0 0 24 24",
      width: "1em",
      height: "1em",
      focusable: "false",
      "aria-hidden": "true",
      role: "presentation"
    }, _react2.default.createElement("g", {
      className: "single-neutral-actions-flag_svg__group0"
    }, _react2.default.createElement("path", {
      className: "single-neutral-actions-flag_svg__path0",
      d: "M14.5 24a.5.5 0 01-.5-.5V12.119c0-.215.137-.406.342-.474l1.29-.43a4.166 4.166 0 011.317-.213 4.17 4.17 0 012.375.733 3.247 3.247 0 001.736.495c.386 0 .763-.066 1.121-.198l.502-.169a1 1 0 011.317.95v5.946a1 1 0 01-.684.948l-.948.316a4.167 4.167 0 01-1.318.213 4.173 4.173 0 01-2.375-.733 3.244 3.244 0 00-1.735-.495c-.386 0-.763.067-1.121.198l-.819.273V23.5a.5.5 0 01-.5.5zm2.437-5.992c.816 0 1.607.228 2.289.66a3.207 3.207 0 002.826.406l.948-.315v-5.946l-.488.163a4.27 4.27 0 01-3.738-.407 3.21 3.21 0 00-2.826-.407l-.948.317v5.946l.489-.163a4.218 4.218 0 011.448-.254z"
    }), _react2.default.createElement("path", {
      className: "single-neutral-actions-flag_svg__path1",
      d: "M7.5 9.5c-2.619 0-4.75-2.131-4.75-4.75S4.881 0 7.5 0s4.75 2.131 4.75 4.75S10.119 9.5 7.5 9.5zm0-8.5C5.432 1 3.75 2.682 3.75 4.75S5.432 8.5 7.5 8.5s3.75-1.682 3.75-3.75S9.568 1 7.5 1z"
    }), _react2.default.createElement("path", {
      className: "single-neutral-actions-flag_svg__path2",
      d: "M.5 18a.5.5 0 01-.5-.5c0-1.54.465-3.022 1.345-4.286a7.512 7.512 0 016.165-3.212c1.535 0 3.014.464 4.275 1.343a.501.501 0 01-.286.91.498.498 0 01-.285-.089 6.455 6.455 0 00-3.705-1.164 6.513 6.513 0 00-5.344 2.783A6.487 6.487 0 001.019 17H11.5a.5.5 0 010 1H.5z"
    })));
    return _this;
  }
  return IconSingleNeutralActionsFlag;
}(_Icon3.default);
exports.default = IconSingleNeutralActionsFlag;